// import React, { useState } from 'react';
// import SubAdminLogModal from '../../components/AdminModal/SubAdminLogModal';

// function UserSubAdmin() {
//   const [customers, setCustomers] = useState([
//     { name: "Name", email: "abc@gmail.com", phone: "9876543210", joinDate: "00/00/0000", status: "Active" },
//     { name: "Name", email: "abc@gmail.com", phone: "9876543210", joinDate: "00/00/0000", status: "Inactive" },
//     { name: "Name", email: "abc@gmail.com", phone: "9876543210", joinDate: "00/00/0000", status: "Active" },
//     { name: "Name", email: "abc@gmail.com", phone: "9876543210", joinDate: "00/00/0000", status: "Inactive" },
//     { name: "Name", email: "abc@gmail.com", phone: "9876543210", joinDate: "00/00/0000", status: "Active" },
//     { name: "Name", email: "abc@gmail.com", phone: "9876543210", joinDate: "00/00/0000", status: "Active" },
//     { name: "Name", email: "abc@gmail.com", phone: "9876543210", joinDate: "00/00/0000", status: "Inactive" },
//     { name: "Name", email: "abc@gmail.com", phone: "9876543210", joinDate: "00/00/0000", status: "Active" },
//   ]);

//   // Function to handle the status change
//   const handleStatusChange = (index, newStatus) => {
//     const updatedCustomers = [...customers];
//     updatedCustomers[index].status = newStatus === "Block" ? "Inactive" : "Active";
//     setCustomers(updatedCustomers);
//   };

//   return (
//     <div className="container mx-auto p-4">
//       {/* Add Customer Button */}
//       <div className="flex justify-end mb-4">

//         <SubAdminLogModal/>
//       </div>

//       {/* Responsive Table */}
//       <div className="overflow-x-auto max-w-full border rounded-xl mt-10">
//         <table className="min-w-full border border-gray-200">
//           <thead className="bg-gray-100">
//             <tr>
//               <th className="p-3 border-b border-r text-left text-sm font-semibold text-gray-700">Customer Name</th>
//               <th className="p-3 border-b border-r text-left text-sm font-semibold text-gray-700">Email Id</th>
//               <th className="p-3 border-b border-r text-left text-sm font-semibold text-gray-700">Phone Number</th>
//               <th className="p-3 border-b border-r text-left text-sm font-semibold text-gray-700">Join Date</th>
//               <th className="p-3 border-b border-r text-left text-sm font-semibold text-gray-700">Status</th>
//               <th className="p-3 border-b border-r text-left text-sm font-semibold text-gray-700">Change Status</th>
//             </tr>
//           </thead>
//           <tbody>
//             {customers.map((customer, index) => (
//               <tr key={index} className="hover:bg-gray-50">
//                 <td className="p-3 border-b border-r text-gray-700 text-sm">{customer.name}</td>
//                 <td className="p-3 border-b border-r text-gray-700 text-sm">{customer.email}</td>
//                 <td className="p-3 border-b border-r text-gray-700 text-sm">{customer.phone}</td>
//                 <td className="p-3 border-b border-r text-gray-700 text-sm">{customer.joinDate}</td>
//                 <td className="p-3 border-b border-r">
//                   <span
//                     className={`px-3 py-1 rounded-full text-white text-sm flex items-center justify-center min-w-[80px] ${
//                       customer.status === "Active" ? "bg-green-500" : "bg-red-500"
//                     }`}
//                   >
//                     {customer.status}
//                   </span>
//                 </td>
//                 <td className="p-3 border-b flex justify-center text-sm">
//                   <select
//                     className="border border-gray-300 rounded px-2 py-1"
//                     value={customer.status === "Active" ? "Unblock" : "Block"}
//                     onChange={(e) => handleStatusChange(index, e.target.value)}
//                   >
//                     <option value="Unblock">Unblock</option>
//                     <option value="Block">Block</option>
//                   </select>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }

// export default UserSubAdmin;

import React, { useState, useEffect } from 'react';
import { FaUserCheck, FaUserSlash } from "react-icons/fa";
import { MdOutlineAccountBalanceWallet } from "react-icons/md";
import { RxLapTimer } from "react-icons/rx";
import { FaRegCalendarAlt } from "react-icons/fa";
import SubAdminLogModal from '../../components/AdminModal/SubAdminLogModal';
import { useAuth } from '../../context/AuthContext';
import { ScaleLoader } from "react-spinners";

function UserSubAdmin() {
  const { getAllSubAdmins } = useAuth();
  const [filter, setFilter] = useState("All");
  const [customers, setCustomers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchSubAdmins = async () => {
      setIsLoading(true);
      const result = await getAllSubAdmins();
      if (result.success && result.data && result.data.Data) {
        // Map backend data to frontend structure if necessary, or use directly
        // Assuming backend returns a list in result.data.Data based on other API patterns
        const mappedData = result.data.Data.map(sub => ({
          name: `${sub.first_name} ${sub.last_name}`,
          mail: sub.email,
          joinDate: sub.date_joined ? new Date(sub.date_joined).toLocaleDateString() : "N/A",
          phone: sub.phone_number || "N/A", // Adjust based on actual API response keys
          status: sub.is_active ? "Active" : "Inactive",
          location: sub.location || "N/A"
        }));
        setCustomers(mappedData);
      } else {
        console.error("Failed to fetch sub-admins or empty list");
        setCustomers([]);
      }
      setIsLoading(false);
    };

    fetchSubAdmins();
  }, []);

  // Filter customers based on the selected filter
  const filteredCustomers = filter === "All" ? customers : customers.filter((customer) => customer.status === filter);

  return (
    <div className="container mx-auto p-4">
      {/* Add Customer Button */}
      <div className="flex justify-end mb-4">
        <SubAdminLogModal />
      </div>

      {/* Tabs Section */}
      <div className="flex items-center justify-between border-b border-gray-300 w-full mb-5">
        <button
          onClick={() => setFilter("All")}
          className={`flex flex-col items-center gap-1 ${filter === "All" ? "text-green-600" : "text-gray-400"
            }`}
        >
          <div className="flex items-center gap-2">
            <MdOutlineAccountBalanceWallet className='text-xl' />
            <span className="font-semibold">All</span>
          </div>
          {filter === "All" && <div className="w-full h-1 bg-green-600"></div>}
        </button>

        <button
          onClick={() => setFilter("Pending")}
          className={`flex flex-col items-center gap-1 ${filter === "Pending" ? "text-green-600" : "text-gray-400"
            }`}
        >
          <div className="flex items-center gap-2">
            <RxLapTimer className="text-xl" />
            <span className="font-medium">Pending</span>
          </div>
          {filter === "Pending" && <div className="w-full h-1 bg-green-600"></div>}
        </button>

        <button
          onClick={() => setFilter("Active")}
          className={`flex flex-col items-center gap-1 ${filter === "Active" ? "text-green-600" : "text-gray-400"
            }`}
        >
          <div className="flex items-center gap-2">
            <FaUserCheck className="text-xl" />
            <span className="font-medium">Active</span>
          </div>
          {filter === "Active" && <div className="w-full h-1 bg-green-600"></div>}
        </button>

        <button
          onClick={() => setFilter("Inactive")}
          className={`flex flex-col items-center gap-1 ${filter === "Inactive" ? "text-green-600" : "text-gray-400"
            }`}
        >
          <div className="flex items-center gap-2">
            <FaUserSlash className="text-xl" />
            <span className="font-medium">Inactive</span>
          </div>
          {filter === "Inactive" && <div className="w-full h-1 bg-green-600"></div>}
        </button>
      </div>


      {/* Table Section */}
      <div className="overflow-x-auto mt-4">
        <table className="w-full text-left">
          <thead>
            <tr>
              <th className="py-3 px-4 text-green-500 text-sm font-medium">Sub Admin Name</th>
              <th className="py-3 px-4 text-green-500 text-sm font-medium">Mail ID</th>
              <th className="py-3 px-4 text-green-500 text-sm font-medium">Join Date</th>
              <th className="py-3 px-4 text-green-500 text-sm font-medium">Location</th>
              <th className="py-3 px-4 text-green-500 text-sm font-medium">Phone Number</th>
              <th className="py-3 px-4 text-green-500 text-sm font-medium">Status</th>
              <th className="py-3 px-4"></th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="7" className="py-10">
                  <div className="flex justify-center">
                    <ScaleLoader color="#FFAE00" height={30} width={4} radius={2} margin={2} />
                  </div>
                </td>
              </tr>
            ) : filteredCustomers.length > 0 ? (
              filteredCustomers.map((customer, index) => (
                <tr key={index}>
                  <td>
                    <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                      {customer.name || "Name"}
                    </div>
                  </td>
                  <td className="py-3 px-4">
                    <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                      {customer.mail || "Mail ID"}
                    </div>
                  </td>
                  <td className="py-3 px-4">
                    <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm flex items-center gap-2">
                      {customer.joinDate || "N/A"}
                      <FaRegCalendarAlt className="text-gray-400 text-base" />
                    </div>
                  </td>
                  <td className="py-3 px-4">
                    <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                      {customer.location || "location"}
                    </div>
                  </td>
                  <td className="py-3 px-4">
                    <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                      {customer.phone || "Number"}
                    </div>
                  </td>
                  <td className="py-3 px-4">
                    <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                      {customer.status || "Inactive"}
                    </div>
                  </td>

                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center py-4 text-gray-600">No sub-admins found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

    </div>
  )
}

export default UserSubAdmin;